import { useState, useCallback, useRef } from 'react';

const useResizeObserver = (): {
    width: number;
    height: number;
    resizedContainerRef: (container: HTMLDivElement) => void;
} => {
    const [width, setWidth] = useState<number>(0);
    const [height, setHeight] = useState<number>(0);

    let resizeObserverObj: any = null;
    if (window.ResizeObserver) {
        resizeObserverObj = new ResizeObserver((entries: ResizeObserverEntry[]) => {
            setWidth(entries[0]?.target.scrollWidth);
            setHeight(entries[0]?.target.scrollHeight);
        });
    } else {
        // the else is for the tests, where it's not defined
        resizeObserverObj = { observe: () => undefined, disconnect: () => undefined };
    }

    const resizeObserver = useRef<ResizeObserver>(resizeObserverObj);

    const resizedContainerRef = useCallback(
        (container: HTMLDivElement) => {
            if (container !== null) {
                resizeObserver.current.observe(container);
            } else if (resizeObserver.current) {
                resizeObserver.current.disconnect();
            }
        },
        [resizeObserver.current]
    );

    return { width, height, resizedContainerRef };
};

export default useResizeObserver;
